import { EixoForm } from '@presentation/components/organisms'
import { EditModal } from '@presentation/components/templates'
import { EditModalProps } from '@presentation/types/components/templates'

import { validationSchema } from './shared'

type Props = {
  id: string
  onEdit: () => void
}

const EditEixoModal: React.FC<Props> = ({ id, onEdit }) => {
  const modalConfigs: EditModalProps = {
    id,
    path: '/eixos',
    formId: 'edit-eixo',
    nameForTitle: 'Eixo',
    validationSchema,
    onEdit
  }

  return (
    <EditModal {...modalConfigs}>
      <EixoForm />
    </EditModal>
  )
}

export default EditEixoModal
